import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestSvcExpenseList(data) {
        return fetch.post(`${BASE_URL}/api/app/expense/getDataFromTicketId`,data);
    }

    